import { render, staticRenderFns } from "./MoleculeEditionAcademyLegalsEmailSignature.vue?vue&type=template&id=8bf96f3e&"
import script from "./MoleculeEditionAcademyLegalsEmailSignature.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyLegalsEmailSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports